﻿var elements = document.getElementsByClassName("product-card");
var productDetailsEl = document.getElementsByClassName("pdp-basket").item(0);

var pushEnhancedEcommerce = function () {
    pushEcommerce();
}

function getProductDetails() {
    if (productDetailsEl) {
        return getProductDetailObj(productDetailsEl);
    }

    return null;
}

function getProductDetailObj(el) {
    var productObj =
    {
        'name': el.getAttribute("data-name"),
        'id': el.getAttribute("data-google-product-id")
            ?? el.getAttribute("data-product-id")
            ?? el.getAttribute("data-id"),
        'internalId': el.getAttribute("data-product-id") ?? el.getAttribute("data-id"),
        'price': el.getAttribute("data-price"),
        'brand': el.getAttribute("data-brand"),
        'category': el.getAttribute("data-category")
    };

    return productObj;
}

function getProductObj(el) {
    var productObj =
    {
        'name': el.getAttribute("data-name"),
        'id': el.getAttribute("data-google-product-id") 
            ?? el.getAttribute("data-product-id")
            ?? el.getAttribute("data-id"),
        'internalId': el.getAttribute("data-product-id") ?? el.getAttribute("data-id"),
        'price': el.getAttribute("data-price"),
        'brand': el.getAttribute("data-brand"),
        'category': el.getAttribute("data-category"),
        'position': el.getAttribute("data-position"),
        'list': el.getAttribute("data-list")
    };

    return productObj;
}

function pushEcommerce() {
    var products = getProducts();
    var promotions = getPromotions();
    var productDetails = getProductDetails();

    var ecommerceObj = {
        ecommerce: {
            currencyCode: 'GBP'
        },
    }

    if (products.length > 0) {
        ecommerceObj.ecommerce.eec = {
            impressionView: { products }
        };
    }

    if (promotions.length > 0) {
        ecommerceObj.ecommerce.eec.promoView = {
            promoView: { promotions: promotions }
        };
    }

    if (productDetails != null) {
        ecommerceObj.ecommerce.eec = {
            detail: { products: [productDetails] }
        };
    }

    dataLayer.push({ ecommerce: null });
    dataLayer.push(ecommerceObj);
}

function getProducts() {
    var products = [];

    for (var i = 0; i < elements.length; i++) {
        elements[i].addEventListener('click', onProductClick);

        products.push(getProductObj(elements[i]));
    }

    return products;
}

function onProductClick(e) {
    e.preventDefault();

    var el = e.currentTarget;
    var productObj = getProductObj(el);
    var productUrl = el.getAttribute("href");

    pushProductClick(productObj, productUrl);
}

function getPromotions() {
    var banners = document.querySelector('a.hero-banner');
    var promotionsObj = [];

    if (banners) {
        for (var i = 0; i < banners.length; i++) {
            banners[i].addEventListener('click', onBannerClick);

            promotionsObj.push(getPromotionObj(banners[i]));
        }
    }

    return promotionsObj;
}

function onBannerClick(e) {
    e.preventDefault();

    var el = e.currentTarget;
    var promotionObj = getPromotionObj(el);

    onPromoClick(promotionObj);
}

function getPromotionObj(el) {
    var promotionObj =
    {
        'id': el.getAttribute("data-id"),
        'name': el.getAttribute("data-name"),
        'creative': el.getAttribute("data-creative"),
        'position': el.getAttribute("data-position"),
        'destinationUrl': el.getAttribute("href")
    }

    return promotionObj;
}

function onPromoClick(promoObj) {
    dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
    dataLayer.push({
        'event': 'eec.promoClick',
        'ecommerce': {
            'promoClick': {
                'promotions': [promoObj]
            }
        }
    });

    document.location = promoObj.destinationUrl;

}

function pushProductClick(productObj, productUrl) {
    dataLayer.push({ ecommerce: null });
    dataLayer.push({
        'event': 'eec.productClick',
        'ecommerce': {
            'click': {
                'products': [productObj]
            }
        }
    });

    if (productUrl)
        document.location = productUrl;
}

function pushAddToCart(productId, quantity = 1) {
    var product = getProductsToAddRemove(productId);
    product.quantity = quantity;

    dataLayer.push({ ecommerce: null });
    dataLayer.push({
        'event': 'eec.addToCart',
        'ecommerce': {
            'add': {
                'products': [product]
            }
        }
    });
}

function getProductsToAddRemove(productId) {
    var productContainer = document.querySelector(`[data-id="${productId}"]`);

    if (!productContainer)
        productContainer = document.querySelector(`[data-product-id='${productId}']`);

    if (!productContainer)
        return;

    return getProductDetailObj(productContainer);
}

function pushRemoveFromCart(productId, quantity = 1) {
    var product = getProductsToAddRemove(productId);
    product.quantity = quantity;

    dataLayer.push({ ecommerce: null });
    dataLayer.push({
        'event': 'eec.removeFromCart',
        'ecommerce': {
            'remove': {
                'products': [product]
            }
        }
    });

}

function getCheckoutProducts() {
    var products = [];
    var el = document.getElementsByClassName("basket-item");

    for (var i = 0; i < el.length; i++) {
        products.push(getProductDetailObj(el[i]));
    }

    return products;
}

function getBasketItems(step, option, basketItemsURL) {
    fetch(basketItemsURL, {
        method: "POST"
    }).then(response => response.json())
        .then(function (result) {
            var products = result.basketVm.Items;
            var basketContainer = document.getElementById("basketItemsContainer");
            var ulElemen = document.createElement("ul")
            var liElem = "";

            if (products) {
                products.forEach(function (item) {
                    liElem +=
                        `<li class="basket-item" 
                                    data-name="${item.Title}"
                                    data-price="${item.Price}"
                                    data-quantity="${item.Quantity}"
                                    data-id="${item.ID}"
                                    data-google-product-id="${item.GoogleProductID || ''}" 
                                    data-product-id="${item.ProductID}"
                                    data-category="${item.CategoryDescription}"
                                    data-brand="${item.BrandDescription}">
                                </li>`
                });
            }

            ulElemen.innerHTML = liElem;
            basketContainer.append(ulElemen);
            pushCheckout(step, option);
        });
}

function onCheckout(step, option, basketItemsURL) {
    if (basketItemsURL) {
        getBasketItems(step, option, basketItemsURL);
    }
    else {
        pushCheckout(step, option);
    }
}

function pushCheckout(step, option) {
    var products = getCheckoutProducts();
    dataLayer.push({ ecommerce: null });

    var ecommerceObj = {
        event: 'eec.checkout',
        ecommerce: {
            checkout: {
                actionField: { step: step },
            }
        }
    }

    if (products && products.length > 0)
        ecommerceObj.ecommerce.checkout.products = products;

    if (option)
        ecommerceObj.ecommerce.checkout.actionField.option = option.toLowerCase();

    dataLayer.push(ecommerceObj);
}

function onCheckoutOption(step, checkoutOption) {
    dataLayer.push({ ecommerce: null });
    dataLayer.push({
        'event': 'checkoutOption',
        'ecommerce': {
            'checkout_option': {
                'actionField': { 'step': step, 'option': checkoutOption }
            }
        }
    });
}


function pushProductView() {
    dataLayer.push({ ecommerce: null });
    dataLayer.push({
        'event': 'eec.detail',
        'ecommerce': {
            'detail': {
                'products': [getProductDetailObj(productDetailsEl)]
            }
        }
    });
}

window.onload = function () {
    pushEcommerce();
}

export { pushEnhancedEcommerce, pushAddToCart, pushRemoveFromCart, onCheckout, onCheckoutOption, pushProductView };